import { Button, Form } from 'antd';
import { useCallback } from 'react';
import ScheduleCGUStep from 'components/schedule/ScheduleCGUStep';
import ScheduleDateStep from 'components/schedule/ScheduleDateStep';
import { ScheduleType } from 'components/schedule/ScheduleType';
import { useAppDispatch } from 'stores/hooks';
import { createMeetingAsync } from 'stores/meetings/meetingsSlice';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import {
  MEETING_TYPES,
  Meeting,
  MeetingType,
} from 'commons/types/meetingsTypes';
import { Patient } from 'commons/types/patientsTypes';

const SCHEDULE_STEPS = {
  date_choice: 'date',
  cgu: 'cgu',
};

interface ScheduleDefaultProps {
  patient: Patient | undefined;
  form: FormInstance<any>;
  defaultScheduledForm: ScheduleType;
  step: string;
  hideCGUs: boolean;
  nextRdvType: MeetingType;
  nextMeeting: Meeting | undefined;
  onChangeStep: (nextStep: string) => () => void;
}

export default function ScheduleDefault({
  patient,
  form,
  defaultScheduledForm,
  step,
  nextRdvType,
  nextMeeting,
  hideCGUs,
  onChangeStep,
}: ScheduleDefaultProps) {
  const dispatch = useAppDispatch();
  const onFinalize = useCallback(
    (schedule: ScheduleType) => {
      dispatch(
        createMeetingAsync({
          ...schedule,
          type: nextRdvType,
          serviceID: form.getFieldValue('serviceID') || '',
        }),
      );
    },
    [dispatch, form, nextRdvType],
  );

  return (
    <Form
      form={form}
      name='schedule-form'
      onFinish={onFinalize}
      initialValues={defaultScheduledForm}
      className='flex flex-col items-center'
    >
      <div
        className={step === SCHEDULE_STEPS.date_choice ? 'w-full' : 'hidden'}
      >
        <ScheduleDateStep
          onNext={onChangeStep(SCHEDULE_STEPS.cgu)}
          form={form}
          nextRdvType={nextRdvType}
          patient={patient}
          doctorID={
            nextRdvType === MEETING_TYPES.RDV_PPC
              ? nextMeeting?.doctor?.wp_id || ''
              : ''
          }
        />
      </div>
      <div className={step === SCHEDULE_STEPS.cgu ? 'w-full' : 'hidden'}>
        <Button
          onClick={onChangeStep(SCHEDULE_STEPS.date_choice)}
          type='text'
        >
          Retour
        </Button>
        <ScheduleCGUStep
          form={form}
          hideCGUs={hideCGUs}
          nextRdvType={nextRdvType}
        />
      </div>
    </Form>
  );
}
